/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Validation_Cnh_InvalidInputs */

const en_case_validation_cnh_invalid = /** @type {(inputs: Case_Validation_Cnh_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid CNH.`)
};

const pt_br2_case_validation_cnh_invalid = /** @type {(inputs: Case_Validation_Cnh_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe uma CNH válida.`)
};

/**
* | output |
* | --- |
* | "Enter a valid CNH." |
*
* @param {Case_Validation_Cnh_InvalidInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_validation_cnh_invalid = /** @type {((inputs?: Case_Validation_Cnh_InvalidInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Validation_Cnh_InvalidInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_validation_cnh_invalid(inputs)
	return pt_br2_case_validation_cnh_invalid(inputs)
});